// extracted by mini-css-extract-plugin
export default {"boxselects":"FilterBar_boxselects__vx9OA","box":"FilterBar_box__uqv5d"};